'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import UIFlex from 'UIComponents/layout/UIFlex';
import { BATTLESHIP } from 'HubStyleTokens/colors';
const AbsoluteFlex = styled(UIFlex).withConfig({
  displayName: "CurrentPlanTag__AbsoluteFlex",
  componentId: "sc-1tkfr9f-0"
})(["position:absolute;top:0;left:0;"]);
const Tag = styled(UITag).withConfig({
  displayName: "CurrentPlanTag__Tag",
  componentId: "sc-1tkfr9f-1"
})(["border-color:", ";border-top:0;border-left:0;"], BATTLESHIP);

const CurrentPlanTag = () => {
  return /*#__PURE__*/_jsx(AbsoluteFlex, {
    justify: "start",
    children: /*#__PURE__*/_jsx(Tag, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.highlightedMerchCards.currentPlan"
      })
    })
  });
};

export default CurrentPlanTag;